/* eslint-disable react/no-unescaped-entities */
import { Link } from "react-router-dom";

const Disclaimer = () => (
  <div className="my-7 p-5 rounded-2xl border border-[#bc6c25]/30 bg-[#bc6c25]/5 text-[#1a2421] text-sm leading-relaxed">
    <strong>Aviso médico:</strong> este artículo es informativo. No sustituye consulta médica. <strong>No suspendas medicamentos</strong> sin hablar antes con tu profesional de salud.
  </div>
);

const Callout = ({ children }) => (
  <div className="my-7 p-5 border-l-4 border-[#bc6c25] bg-[#bc6c25]/5 rounded-r-2xl text-[#1a2421] text-[15px] leading-relaxed">{children}</div>
);

const TOC = ({ items }) => (
  <nav className="my-7 p-5 bg-[#f0ebe1] rounded-2xl border border-[#2c4a3b]/8 not-prose">
    <p className="text-[10px] uppercase tracking-[0.22em] text-[#bc6c25] font-bold">En este artículo</p>
    <ol className="mt-3 space-y-1.5 text-sm text-[#1a2421]">
      {items.map((it, i) => (
        <li key={i} className="flex gap-2"><span className="text-[#bc6c25] font-bold">{i + 1}.</span><a href={`#${it.id}`} className="hover:text-[#bc6c25]">{it.label}</a></li>
      ))}
    </ol>
  </nav>
);

const Esperanza = () => (
  <div className="my-9 p-7 rounded-3xl bg-gradient-to-br from-[#1a2421] to-[#2c4a3b] text-[#f9f6f0] not-prose">
    <p className="text-[10px] uppercase tracking-[0.28em] text-[#bc6c25] font-semibold">Eliora Longevity</p>
    <h3 className="font-serif text-2xl md:text-3xl mt-2 leading-tight">Si tienes vida, tienes esperanza.</h3>
    <p className="text-sm text-[#f9f6f0]/75 mt-3 leading-relaxed">Hagamos juntos un protocolo personalizado. 3 minutos. Es cortesía.</p>
    <Link to="/#quiz" className="mt-5 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#bc6c25] hover:bg-[#9c581e] text-white text-sm font-semibold">Hacer el Quiz Wellness →</Link>
  </div>
);

export const ARTICLE_CONTENT_7 = {
  /* 25. Frutos rojos y salud de la mujer */
  "frutos-rojos-salud-de-la-mujer": (
    <>
      <p>Si pudiera regalarle a cada mujer mexicana un solo hábito alimenticio que cambie su salud a partir de los 35 años, sería este: <strong>una taza de frutos rojos al día</strong>. Suena simple. Pero la ciencia detrás es contundente —y los beneficios específicos para el cuerpo femenino son únicos.</p>
      <TOC items={[
        { id: "polifenoles", label: "Polifenoles: la joya bioquímica" },
        { id: "hormonas", label: "Equilibrio hormonal y menopausia" },
        { id: "corazon", label: "Salud cardiovascular femenina" },
        { id: "piel", label: "Piel, colágeno y antiedad" },
        { id: "mente", label: "Cerebro y prevención cognitiva" },
        { id: "como", label: "Cómo y cuánto consumir" },
      ]} />

      <h2 id="polifenoles">Polifenoles: la joya bioquímica</h2>
      <p>Frutillas, arándanos, frambuesas, moras, granada, cerezas, açaí. Su color rojo-púrpura intenso viene de las <strong>antocianinas</strong>, una familia de polifenoles con poder antiinflamatorio y antioxidante superior a la vitamina C. Una taza de moras aporta más antioxidantes que 5 manzanas.</p>

      <h2 id="hormonas">Equilibrio hormonal y menopausia</h2>
      <p>Los polifenoles de los frutos rojos son <strong>fitoestrógenos suaves</strong>: modulan receptores de estrógeno sin sobreestimular. Estudios en mujeres perimenopáusicas muestran reducción de calores y mejor estado de ánimo con consumo regular. Profundiza en <Link to="/blog/menopausia-y-glutation">menopausia y glutatión</Link>.</p>

      <h2 id="corazon">Salud cardiovascular femenina</h2>
      <p>Las mujeres tras los 50 igualan a los hombres en riesgo cardiovascular. Un meta-análisis en <em>Circulation</em> mostró que mujeres que consumen ≥3 porciones/semana de moras o fresas reducen riesgo de infarto en 32%.</p>

      <Callout><strong>Mecanismo:</strong> las antocianinas mejoran la función endotelial, reducen oxidación del LDL y bajan presión arterial 4-7 mmHg sostenidos.</Callout>

      <h2 id="piel">Piel, colágeno y antiedad</h2>
      <p>Los polifenoles bloquean enzimas que degradan colágeno (colagenasas) activadas por UV. Combinados con vitamina C natural, estimulan síntesis de colágeno tipo I. Resultado: menos arrugas, mayor firmeza.</p>

      <h2 id="mente">Cerebro y prevención cognitiva</h2>
      <p>Un estudio de Harvard de 16 años en 16,000 mujeres mostró que quienes comían arándanos y fresas ≥2 veces/semana retrasaron el deterioro cognitivo <strong>hasta 2.5 años</strong>. La barrera hematoencefálica deja pasar las antocianinas hacia el hipocampo (memoria).</p>

      <h2 id="como">Cómo y cuánto consumir</h2>
      <ul>
        <li><strong>Cantidad:</strong> 1 taza (~150 g) al día, frescos o congelados (mismos beneficios).</li>
        <li><strong>Combinaciones:</strong> con yogur natural + nueces; smoothie con Immunocal Original; sobre avena cocida.</li>
        <li><strong>Granada:</strong> medio fruto al día, especialmente bueno para próstata (sí, también para tu pareja).</li>
        <li><strong>Açaí en polvo:</strong> 1 cucharadita en yogur. Cuida que no tenga azúcar añadida.</li>
        <li><strong>Evitar:</strong> jugos comerciales de frutos rojos (puro azúcar, polifenoles destruidos).</li>
      </ul>

      <Callout><strong>Combina con Immunocal:</strong> el glutatión recicla los polifenoles, multiplicando su efecto antioxidante. Frutos rojos en el desayuno + <Link to="/immunocal">Immunocal</Link> en ayunas es uno de los protocolos más rentables nutricionalmente.</Callout>

      <Esperanza />
      <p>Para más estrategias específicas para mujeres +40, lee <Link to="/blog/menopausia-y-glutation">menopausia y glutatión</Link>.</p>
    </>
  ),

  /* 26. Optimizer Performance - 3 cafeinas para deportistas */
  "optimizer-performance-3-cafeinas-deportistas": (
    <>
      <p>Si entrenas en serio —corres, juegas fútbol, levantas pesas, haces CrossFit— sabes que la cafeína común del café te da un pico de energía con bajón asegurado en 90 minutos. <strong>Optimizer Performance</strong> de Immunotec resuelve eso con una mezcla inteligente de <strong>3 fuentes de cafeína</strong> con liberación escalonada. Te explico cómo funciona y por qué cambia tu rendimiento.</p>
      <TOC items={[
        { id: "problema", label: "El problema con la cafeína tradicional" },
        { id: "las-3", label: "Las 3 cafeínas de Optimizer Performance" },
        { id: "beneficios", label: "Beneficios para deportistas" },
        { id: "como-tomarlo", label: "Cómo y cuándo tomarlo" },
        { id: "combinaciones", label: "Combinaciones ganadoras" },
      ]} />

      <h2 id="problema">El problema con la cafeína tradicional</h2>
      <p>La cafeína anhidra (la del café o energéticos típicos) se absorbe rápido, picos a los 30-45 min, vida media corta de 3-4 horas. Resultado: rendimiento intenso de 1 hora seguido de fatiga rebote, jitters y crash en la segunda hora del entrenamiento.</p>

      <h2 id="las-3">Las 3 cafeínas de Optimizer Performance</h2>
      <ol>
        <li><strong>Cafeína de Guaraná (Paullinia cupana):</strong> liberación lenta y sostenida porque está unida a taninos vegetales. Energía estable durante 4-6 horas, sin pico ni crash.</li>
        <li><strong>Cafeína anhidra (extracto de café verde):</strong> activación inmediata. Te despierta en los primeros 20 minutos y prepara el sistema nervioso para esfuerzo intenso.</li>
        <li><strong>Cafeína de Té Verde + L-Teanina:</strong> aporta energía moderada con foco mental. La teanina <em>contrarresta los nervios</em> de la cafeína anhidra, dejando solo la claridad mental sin ansiedad.</li>
      </ol>

      <Callout><strong>Sinergia:</strong> las 3 fuentes liberan cafeína en momentos distintos. Tienes energía explosiva al inicio, sostenida durante el entrenamiento, y vuelves a la normalidad sin crash.</Callout>

      <h2 id="beneficios">Beneficios para deportistas</h2>
      <ul>
        <li><strong>Rendimiento sostenido</strong> 3-5 horas (vs 1 hora con café tradicional).</li>
        <li><strong>Mayor potencia explosiva</strong> en sprints, levantamientos, saltos.</li>
        <li><strong>Foco mental sin ansiedad</strong> (la L-Teanina del té verde modula el efecto estimulante).</li>
        <li><strong>Mejor movilización de grasa</strong> como sustrato energético (lipólisis).</li>
        <li><strong>Reducción percepción del esfuerzo</strong> ~15% en estudios.</li>
        <li><strong>Sin crash</strong> ni jitters, gracias a la liberación escalonada.</li>
      </ul>

      <h2 id="como-tomarlo">Cómo y cuándo tomarlo</h2>
      <ul>
        <li><strong>Dosis:</strong> 1 sobre disuelto en 250-350 ml de agua fría.</li>
        <li><strong>Timing:</strong> 30 minutos antes del entrenamiento.</li>
        <li><strong>No exceder:</strong> 1 sobre por sesión. No combinar con café o energéticos el mismo día.</li>
        <li><strong>Evitar después de las 4 p.m.</strong> si entrenas por la tarde — afecta el sueño profundo.</li>
        <li><strong>Sensibles a cafeína:</strong> empieza con medio sobre.</li>
      </ul>

      <h2 id="combinaciones">Combinaciones ganadoras (Immunotec)</h2>
      <ul>
        <li><strong>Pre-entreno:</strong> Optimizer Performance + 1 vaso de agua con electrolitos.</li>
        <li><strong>Post-entreno:</strong> <Link to="/blog/immunocal-sport-para-atletas">Immunocal Sport</Link> con creatina y electrolitos para recuperación.</li>
        <li><strong>Mantenimiento diario:</strong> Immunocal Original en ayunas (precursor de glutatión = recuperación profunda).</li>
        <li><strong>Inflamación articular:</strong> <Link to="/blog/omega-gen-v-5-en-1">Omega Gen V</Link> con la comida principal.</li>
      </ul>

      <Esperanza />
      <p>¿Quieres una rutina deportiva completa con Immunotec? <Link to="/#quiz">Haz el quiz wellness gratis</Link>.</p>
    </>
  ),

  /* 27. Knutric y diabetes */
  "knutric-diabetes-control-glucemico": (
    <>
      <p>Vivir con diabetes tipo 2 es vivir en una batalla diaria con el azúcar. Mediciones, restricciones, ansiedad por los picos. Una de las herramientas menos conocidas pero más eficaces dentro del portafolio Immunotec es <strong>Knutric</strong>: un alimento funcional diseñado específicamente para apoyar el control glucémico de forma natural y sostenible.</p>
      <Disclaimer />

      <TOC items={[
        { id: "que-es", label: "Qué es Knutric" },
        { id: "ingredientes", label: "Ingredientes clave y su rol" },
        { id: "como-actua", label: "Cómo actúa en personas con diabetes" },
        { id: "beneficios", label: "Beneficios reportados" },
        { id: "como-tomarlo", label: "Cómo y cuándo tomarlo" },
        { id: "protocolo", label: "Protocolo combinado con Immunocal" },
      ]} />

      <h2 id="que-es">Qué es Knutric</h2>
      <p>Knutric es un alimento funcional en polvo de Immunotec, formulado con una matriz de <strong>fibra soluble fermentable</strong>, proteínas de calidad, nopal deshidratado y minerales reguladores del metabolismo de la glucosa. No es un medicamento ni reemplaza la insulina o metformina; es un soporte nutricional integral.</p>

      <h2 id="ingredientes">Ingredientes clave y su rol</h2>
      <ul>
        <li><strong>Fibra soluble (inulina, beta-glucano):</strong> ralentiza la absorción de glucosa intestinal → menos picos glucémicos posprandiales.</li>
        <li><strong>Nopal en polvo:</strong> rico en polisacáridos y antioxidantes. Estudios mexicanos muestran reducción de glucosa posprandial hasta 18%.</li>
        <li><strong>Cromo y magnesio:</strong> mejoran la sensibilidad a la insulina (mineral cofactor).</li>
        <li><strong>Proteína de suero parcialmente hidrolizada:</strong> saciedad y mantenimiento de masa muscular.</li>
        <li><strong>Vitaminas del complejo B:</strong> apoyan el metabolismo energético sin uso de azúcar.</li>
      </ul>

      <Callout><strong>Pieza clave:</strong> el cromo apoya la unión de la insulina con su receptor. En personas con resistencia a la insulina, su deficiencia (común en dieta moderna) empeora el control glucémico.</Callout>

      <h2 id="como-actua">Cómo actúa en personas con diabetes</h2>
      <ol>
        <li><strong>Reduce el pico glucémico posprandial:</strong> la fibra y el nopal forman un gel intestinal que ralentiza la absorción de carbohidratos.</li>
        <li><strong>Mejora sensibilidad a la insulina:</strong> cromo y magnesio actúan como cofactores enzimáticos.</li>
        <li><strong>Alimenta microbiota saludable:</strong> la fibra fermentable genera butirato, que reduce inflamación intestinal (clave en diabetes).</li>
        <li><strong>Sustituye una comida hipercalórica:</strong> ideal como desayuno o cena ligera.</li>
        <li><strong>Reduce antojos de azúcar:</strong> la saciedad de la proteína + fibra estabiliza la glucosa por horas.</li>
      </ol>

      <h2 id="beneficios">Beneficios reportados</h2>
      <ul>
        <li>Glucosa en ayunas más estable.</li>
        <li>Menor variabilidad glucémica diaria.</li>
        <li>Reducción gradual de hemoglobina glicosilada (HbA1c) en 90 días.</li>
        <li>Mejor digestión y regularidad intestinal.</li>
        <li>Pérdida de peso saludable como efecto secundario.</li>
        <li>Mayor energía sostenida sin picos.</li>
      </ul>

      <h2 id="como-tomarlo">Cómo y cuándo tomarlo</h2>
      <ul>
        <li><strong>Dosis típica:</strong> 1 medida (~30 g) disuelta en 250 ml de agua fría o leche vegetal.</li>
        <li><strong>Mejor momento:</strong> desayuno (sustituye o complementa) o como cena ligera.</li>
        <li><strong>Mezclar suavemente</strong> con cuchara o agitar (no licuadora).</li>
        <li><strong>Empezar gradualmente:</strong> media medida los primeros 3 días si tienes intestino sensible (la fibra puede generar gases iniciales).</li>
        <li><strong>Hidratación:</strong> tomar ≥2 L de agua al día (la fibra necesita líquido).</li>
      </ul>

      <h2 id="protocolo">Protocolo combinado con Immunocal</h2>
      <p>El combo ideal Immunotec para diabetes:</p>
      <ul>
        <li><strong>Ayunas:</strong> 1 sobre <Link to="/immunocal">Immunocal</Link> en agua fría (precursor de glutatión → protege tejidos del daño oxidativo de la diabetes).</li>
        <li><strong>Desayuno (45 min después):</strong> Knutric con leche de almendra + 1 puñado de frutos rojos.</li>
        <li><strong>Comida principal:</strong> proteína + verduras + grasas buenas. Caminar 10-15 min después.</li>
        <li><strong>Suplementación adicional:</strong> Omega-3 con la comida, magnesio glicinato antes de dormir.</li>
        <li><strong>Cero ultraprocesados, azúcares refinados, refrescos.</strong></li>
      </ul>

      <Callout><strong>Importante:</strong> mide tu glucosa diariamente y ajusta con tu médica. NO suspendas metformina o insulina sin orden médica. Knutric es soporte nutricional, no reemplazo farmacológico.</Callout>

      <Esperanza />
      <p>Para entender por qué empezamos por el glutatión, lee <Link to="/blog/diabetes-tipo-2-y-glutation">diabetes tipo 2 y glutatión</Link>.</p>
    </>
  ),
};

export default ARTICLE_CONTENT_7;
